module.exports = __webpack_public_path__ + "img/Atari.b4d0dc5c.jpeg";